export const QUERY_PARAM_TEAM_INVITE_ID = 'teamInviteId';
export const QUERY_PARAM_PAGE_INVITE_ID = 'pageInviteId';
